// Custom Size Variant Display Handler
// Shows only width in pills but full dimensions when selected

class SizeVariantDisplay {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupSizeHandlers());
    } else {
      this.setupSizeHandlers();
    }
  }

  setupSizeHandlers() {
    // Find all variant selectors
    const variantSelectors = document.querySelectorAll('variant-selects');
    
    variantSelectors.forEach(selector => {
      this.handleVariantSelector(selector);
    });
  }

  handleVariantSelector(variantSelector) {
    // Find size-related inputs within this selector
    const sizeInputs = variantSelector.querySelectorAll('input[data-full-size]');
    
    if (sizeInputs.length === 0) return;

    // Set up event listeners for size inputs
    sizeInputs.forEach(input => {
      input.addEventListener('change', (e) => {
        if (e.target.checked) {
          this.updateSelectedValueDisplay(e.target);
        }
      });

      // Handle initial state
      if (input.checked) {
        this.updateSelectedValueDisplay(input);
      }
    });
  }

  updateSelectedValueDisplay(input) {
    const fullSize = input.dataset.fullSize;
    if (!fullSize) return;

    // Find the corresponding selected value display
    const fieldset = input.closest('fieldset');
    if (!fieldset) return;

    const selectedValueSpan = fieldset.querySelector('[data-selected-value]');
    if (selectedValueSpan) {
      selectedValueSpan.textContent = fullSize;
    }
  }
}

// Initialize when script loads
new SizeVariantDisplay(); 